export const idleTimer = {
    tokenRefreshInterval: 10,    // in minutes
    timeoutInterval: 30,        // in minutes
    warningTime: 5,             // in minutes
}